
import React from 'react'
import PropTypes from 'prop-types'
import QueryManager from './Query'
import gql from 'graphql-tag'
import { get } from 'lodash'

const GET_ABM_RESOURCES = gql`query getResources {
  getResources {
    count
    results {
      ... on Resource {
        id
        roleName
        name
        resources
      }
    }
  }
}`

const GetABMResources = ({ children, ...props }) => {
  return (
    <QueryManager query={GET_ABM_RESOURCES} {...props}>
      {({ data, loading, fetchMore, refetch }) =>
        children({
          data: get(data, 'getResources.results', []),
          count: get(data, 'getResources.count', 0),
          refetch,
          loading
        })}
    </QueryManager>
  )
}

GetABMResources.propTypes = {
  children: PropTypes.any
}

export default GetABMResources
